import React from "react";
import "./wallet-discover-page.css";

export default function GooglePayPage() {
  return (
    <div className="main">
    <main className="applePayPage">
      <div className="applePayPage__logo applePayPage__logo--google">
        <img className="applePayPage__logo-image applePayPage__logo-image--google" src="/assets/google-wallet/GoogleWalletLogo.svg" alt="Google Pay" />
      </div>
      <h1>Discover Google Pay</h1>
      <p>This page explains how to use Google Pay (Google Wallet) for fast and secure payments with your Android devices.</p>

      <h2>1 Pay quickly and securely</h2>
      <p>Google Pay lets you pay in stores, apps, and online using your Android phone or smartwatch without needing your physical card.</p>

      <h2>2 How it works</h2>
      <ol>
        <li>Open the Google Wallet app.</li>
        <li>Add your gift card. (Verify the card if required.)</li>
        <li>Unlock your phone and tap it on a contactless payment terminal.</li>
      </ol>

      <h2>3 Advantages</h2>
      <ul>
        <li>Fast contactless payments</li>
        <li>No need to carry your wallet</li>
        <li>Works at merchants who participate in the gift card program</li>
      </ul>

      <h2>4 Security</h2>
      <p>Google Pay protects your payment information using encryption and virtual card numbers, so merchants never see your real card number. Authentication is done with your phone&rsquo;s lock screen, fingerprint, or face recognition.</p>

      <h2>5 Compatible devices</h2>
      <ul>
        <li>Android smartphones with NFC</li>
        <li>Wear OS smartwatches</li>
      </ul>

      <h2>6 Where you can use it</h2>
      <p>You can use Google Pay anywhere contactless payments are accepted or where you see the Google Pay/contactless symbols at the merchants that participate in the gift card program.</p>
      <p>
        You can also read Google&rsquo;s official English pages here:{" "}
        <a href="https://support.google.com/wallet/answer/12060043?hl=en" target="_blank" rel="noopener noreferrer">Google Wallet Help &ndash; Tap to pay</a>
        {" "}and{" "}
        <a href="https://safety.google/intl/en/products/pay/" target="_blank" rel="noopener noreferrer">Google Pay Security Center</a>
      </p>
    </main>
    </div>
  );
}
